import { render, staticRenderFns } from "./ShopperSelect.vue?vue&type=template&id=6e95da0a&"
import script from "./ShopperSelect.vue?vue&type=script&lang=js&"
export * from "./ShopperSelect.vue?vue&type=script&lang=js&"
import style0 from "./ShopperSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports